import { CalendarDayIcon, Typography } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { L } from '../../../../../../../../Translations';

interface Props {
  startOn: string;
}

function UpcomingDatesInfo({ startOn }: Props) {
  return (
    <div className="flex items-center gap-x-1.5">
      <CalendarDayIcon size="md" />
      <Typography className="tracking-[0.2px]" variant="caption" fontWeight="medium">
        <L localizeable={new Date(startOn)} format={'long-weekday-month-year'} />
      </Typography>
    </div>
  );
}

export default observer(UpcomingDatesInfo);
